import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {ChartAccountsForm} from "./ChartAccountsForm";

export const ChartAccountsEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component="div">
      <ChartAccountsForm />
    </DefaultEdit>
  );
};
